<abc-scroll-view [useNative]="true">
  <div
    fxFlexFill
    fxLayout="column"
    fxLayout.sm="column"
    fxLayout.xs="column"
    class="content-style-class measure-details-container"
  >
    <div fxFlexFill fxLayout="row" class="status-report-padding">
      <div fxLayout="column" fxFlex="65" class="header">
        <!-- Accordions Section -->
        <div class="accordion-style status-report-margin" fxLayout="column" fxLayoutGap="5px">
          <ubt-geods-status-report
            #statusReport
            [measureProgress]="measure.MeasureProgress"
            [lastMeasureProgress]="lastMeasureProgress"
            [measureId]="measure.Id"
            [canManageStatusReport]="permissions.canManageStatusReport"
            (assignReportToMeasure)="assignReportToMeasure($event)"
            (updateReportData)="updateReportData($event)"
            (deleteReport)="deleteReport($event)"
          >
          </ubt-geods-status-report>

          <div class="accordion-style">
            <ubt-geods-description
              [currentMeasure]="measure"
              [canEditDescription]="permissions.canEditDescription"
            ></ubt-geods-description>
          </div>

          <div class="accordion-style">
            @if (showImpl) {
              <ubt-geods-implementation-plan
                [canManageMilestones]="permissions.canManageMilestones"
                [canManageTasks]="permissions.canManageTasks"
                #implementationPlan
                [currentMeasure]="measure"
              >
              </ubt-geods-implementation-plan>
            }
          </div>
           @if (isDesktop()) {
            <ubt-geods-tab-panel  class="tab-panel-desktop"></ubt-geods-tab-panel>
             }
        </div>
      </div>

      <!-- Chart | Details | Comments Section -->
      <div fxLayout="column" fxFlex="35" class="details-fields">
        <div fxLayout="row" fxLayoutAlign="end center">
          <div>
            <abc-button
              stylingMode="text"
              class="btn-navigation"
              icon="chevronleft"
              type="default"
              [disabled]="measureService.currentMeasureIndex === 0"
              (onClick)="navigateToMeasure(-1)"
              [hoverStateEnabled]="false"
              [hint]="previousMeasureDesignation"
            >
            </abc-button>
          </div>
          <div>
            <abc-button
              stylingMode="text"
              class="btn-navigation"
              icon="chevronnext"
              type="default"
              [disabled]="measureService.currentMeasureIndex == this.appService.measureIds.length - 1"
              (onClick)="navigateToMeasure(1)"
              [hoverStateEnabled]="false"
              [hint]="nextMeasureDesignation"
            >
            </abc-button>
          </div>
        </div>
        @if(isViewReady){
     
          <div class="dx-card card-container card-paddings responsive-paddings progress-style">
            <ubt-geods-approval-request
              [measureProgress]="currentProgressIndex() !== -1 
                ? measure.MeasureProgress[currentProgressIndex()] 
                : null"
              (maturityLevelChanged)="updateMeasureProgress($event)"
            ></ubt-geods-approval-request>
          </div>
        
      }
        <div
          fxLayout="column"
          class="dx-card card-container card-paddings responsive-paddings progress-style"
          fxLayoutGap="10px"
        >
          <div>
            <span class="meausre-progress-title">{{ dataService.res('Ubt-Measure-Detail-Progress-Title') }}</span>
          </div>

          <div class="container-card">
            <ubt-geods-chart
              #chart
              [progressChartData]="measure?.MeasureProgress"
              [showXaxis]="false"
            ></ubt-geods-chart>
          </div>
          <div class="container-card">
            <div fxLayout="row" class="right-fields-container">
              <abc-text-box
                #measureTitle
                [width]="'100%'"
                [(value)]="measure.Title"
                [stylingMode]="'outlined'"
                (onValueChanged)="verifyChanges($event, 'Designation')"
                [label]="dataService.res('Ubt-Measure-List-Title')"
                [labelMode]="'floating'"
                [disabled]="!permissions.canEditMeasureInfos"
              >
              </abc-text-box>
            </div>

            <div fxLayout="row" class="right-fields-container">
              <div fxLayout="column" fxFlex="47">
                <abc-select-box
                  class="drop-down-style"
                  valueExpr="Id"
                  displayExpr="Label"
                  [stylingMode]="'outlined'"
                  [width]="'100%'"
                  [(value)]="measure.ParentId"
                  [dataSource]="subProjects"
                  [label]="dataService.res('Ubt-Measure-List-SubProject')"
                  (onValueChanged)="verifyChanges($event, 'ParentId')"
                  [labelMode]="'floating'"
                  [disabled]="!permissions.canEditMeasureInfos"
                >
                </abc-select-box>
              </div>
              <div fxLayout="column" fxFlex="5"></div>
              <div fxLayout="column" fxFlex="48">
                <abc-select-box
                  class="drop-down-style"
                  valueExpr="value"
                  displayExpr="name"
                  [stylingMode]="'outlined'"
                  [width]="'100%'"
                  [(value)]="measure.Status"
                  [dataSource]="measureStatusOptions"
                  [label]="dataService.res('Ubt-Measure-List-Status')"
                  (onValueChanged)="verifyChanges($event, 'Status')"
                  [labelMode]="'floating'"
                  [disabled]="!permissions.canEditMeasureInfos"
                >
                </abc-select-box>
              </div>
            </div>

            <div fxLayout="row" class="right-fields-container">
              <div fxLayout="column" fxFlex="32">
                <abc-date-box
                  fxLayout="column"
                  fxFill
                  class="date-box-style"
                  class="date-box-style"
                  [(value)]="measure.ReleaseDate"
                  [label]="dataService.res('Ubt-MeasureDetail-Release-On')"
                  [labelMode]="'floating'"
                  (onValueChanged)="verifyChanges($event, 'ReleaseDate')"
                  [disabled]="!permissions.canEditMeasureInfos"
                >
                </abc-date-box>
              </div>
              <div fxLayout="column" fxFlex="2"></div>
              <div fxLayout="column" fxFlex="32">
                <abc-date-box
                  fxLayout="column"
                  fxFill
                  class="date-box-style"
                  class="date-box-style"
                  (onValueChanged)="verifyChanges($event, 'StartDate')"
                  [(value)]="measure.StartDate"
                  [label]="dataService.res('Ubt-MeasureTask-StartDate')"
                  [labelMode]="'floating'"
                  [disabled]="!permissions.canEditMeasureInfos"
                >
                </abc-date-box>
              </div>
              <div fxLayout="column" fxFlex="2"></div>
              <div fxLayout="column" fxFlex="32">
                <abc-date-box
                  fxFill
                  class="date-box-style"
                  [(value)]="measure.EndDate"
                  (onValueChanged)="verifyChanges($event, 'EndDate')"
                  [min]="measure.StartDate"
                  [label]="dataService.res('Ubt-Measure-List-EndDate')"
                  [labelMode]="'floating'"
                  [disabled]="!permissions.canEditMeasureInfos"
                >
                </abc-date-box>
              </div>
            </div>

            <div fxLayout="row" class="right-fields-container">
              <div fxLayout="column" fxFlex="100">
                <abc-select-box
                  fxFill
                  class="drop-down-style"
                  valueExpr="Id"
                  [displayExpr]="dataService.getResponsibleFullName"
                  (onValueChanged)="verifyChanges($event, 'IdRefPersonResponsible')"
                  [dataSource]="measureService.measureResponsibleDataSource"
                  [(value)]="measure.Responsible"
                  [label]="dataService.res('Ubt-CreateMeasure-Responsible')"
                  [labelMode]="'floating'"
                  [disabled]="!permissions.canEditMeasureInfos"
                >
                </abc-select-box>
              </div>
            </div>

            <div fxLayout="row" class="right-fields-container">
              <div fxLayout="column" fxFlex="49">
                <abc-select-box
                  fxFill
                  class="drop-down-style"
                  valueExpr="Id"
                  [displayExpr]="dataService.getResponsibleFullName"
                  (onValueChanged)="verifyChanges($event, 'IdRefPersonAreaManager')"
                  [dataSource]="coreTeamSupervisorDataSource"
                  [(value)]="measure.AreaManager"
                  [label]="dataService.res('Ubt-MeasureDetail-Division-Manager')"
                  [labelMode]="'floating'"
                  [disabled]="!permissions.canEditMeasureInfos"
                >
                </abc-select-box>
              </div>
              <div fxLayout="column" fxFlex="1"></div>
              <div fxLayout="column" fxFlex="49">
                <abc-select-box
                  fxFill
                  class="drop-down-style"
                  valueExpr="Id"
                  [displayExpr]="dataService.getResponsibleFullName"
                  (onValueChanged)="verifyChanges($event, 'IdRefPersonSponsor')"
                  [dataSource]="cachedResponsibles"
                  [(value)]="measure.IdRefPersonSponsor"
                  [label]="dataService.res('Ubt-MeasureDetail-Sponsor')"
                  [labelMode]="'floating'"
                  [disabled]="!permissions.canEditMeasureInfos"
                >
                </abc-select-box>
              </div>
            </div>

            <div fxLayout="row" class="right-fields-container">
              <abc-tag-box
                #assignedMembers
                fxFill
                [dataSource]="measureService.staffMembersDataSource"
                [height]="'100px'"
                [(value)]="assignedMembersIds"
                [displayExpr]="dataService.getResponsibleFullName"
                valueExpr="Id"
                [label]="dataService.res('Ubt-CreateMeasure-Members')"
                [labelMode]="'floating'"
                [showSelectionControls]="true"
                (onSelectionChanged)="addDeleteResource($event)"
                [disabled]="!permissions.canEditMeasureInfos"
              >
              </abc-tag-box>
            </div>
          </div>
        </div>

        <div class="dx-card card-container card-paddings responsive-paddings" class="progress-style">
          <div class="accordion-style">
            <ubt-geods-total-time [collaborators]="collaboratorsTotalTime" [taskList]="measure"></ubt-geods-total-time>
          </div>
        </div>

        <!-- Evalutaion Component -->
        <ubt-geods-measure-evaluation></ubt-geods-measure-evaluation>
        <!-- End Evaluation -->
      </div>

      
    </div>
         @if (!isDesktop()) {
         <ubt-geods-tab-panel class="tab-panel-mobile"> </ubt-geods-tab-panel>
               }
  </div>
</abc-scroll-view>
